import React from 'react';
import { Box, BoxProps } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


export const CalendarDropdown: React.FC<{label: string} & BoxProps> = ({ label, ...props }) => (
  <Box component="span" display="flex" alignItems="center" height="33px" {...props}>
    <Box component="span" pt="2px" pl="4px">
      {label}
    </Box>
    <ArrowDropDownIcon fontSize="small" />
  </Box>
);
